import { Injectable, signal, effect, computed } from '@angular/core';
import { Subject } from 'rxjs';
import { PersistedConfig } from '@core/types/theme.interface';
import { DEFAULT_CONFIG, STORAGE_KEY_CONFIG, DARK, LIGHT } from '@core/const';

@Injectable({ providedIn: 'root' })
export class ThemeLayoutService {
  config = signal<PersistedConfig>(this.loadConfig());
  dashBoardMenuState = new Subject<void>();
  layoutType = computed(() => this.config().layoutType);
  bodyColor = computed(() => this.config().bodyColor);
  theme = computed<'light' | 'dark'>(() => {
    const selectedMode = this.layoutType();
    if (selectedMode === 'light' || selectedMode === 'dark') {
      return selectedMode;
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? DARK : LIGHT;
  });

  constructor() {
    effect(() => {
      localStorage.setItem(STORAGE_KEY_CONFIG, JSON.stringify(this.config()));
    });
  }

  private loadConfig(): PersistedConfig {
    const saved = localStorage.getItem(STORAGE_KEY_CONFIG);
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch {
        // Si hay JSON corrupto, se usa la configuración por defecto.
      }
    }
    return DEFAULT_CONFIG;
  }

  toggleSideDrawer(): void {
    this.dashBoardMenuState.next();
  }

  setLayoutType(mode: 'light' | 'dark' | 'auto'): void {
    this.config.update((cfg) => ({ ...cfg, layoutType: mode }));
  }

  setBodyColor(theme: string): void {
    this.config.update((cfg) => ({ ...cfg, bodyColor: theme }));
  }

  resetConfig(): void {
    this.config.set(DEFAULT_CONFIG);
  }
}
